import { DropDownItemType } from './dropDownItemType';

export const doRoutesNeedToBeUpdated = (
  dropDownRoutes: DropDownItemType[],
  keyToSetActive: string
): boolean => {
  return dropDownRoutes.some(
    (route) => route.key === keyToSetActive && !route.isActive
  );
};

export const isActivityTriggerNeeded = (
  dropDownRoutes: DropDownItemType[],
  keyToSetActive: string | undefined
): boolean => {
  return (
    keyToSetActive !== undefined &&
    doRoutesNeedToBeUpdated(dropDownRoutes, keyToSetActive)
  );
};

export const setSelectedDropDownItemAsActive = (
  dropDownRoutes: DropDownItemType[],
  keyToSetActive: string
): DropDownItemType[] => {
  return dropDownRoutes.map((route) => {
    return {
      ...route,
      isActive: route.key === keyToSetActive
    };
  });
};
